import { render } from "./CloseModal.vue?vue&type=template&id=2b8cc523&scoped=true"
import script from "./CloseModal.vue?vue&type=script&lang=js"
export * from "./CloseModal.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=2b8cc523&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8cc523"]])

export default __exports__